
import React, { Component } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "./ContactSection5.css";

export default class ContactSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
      sending: false,
      status: "",
      statusType: "",
    };

    this.captchaRef = React.createRef();
  }

  sendEmail = (e) => {
    e.preventDefault();

    if (this.state.sending) return;

    if (!this.state.captcha) {
      this.setState({
        status: "נא לאשר שאינכם רובוט לפני שליחת הפנייה.",
        statusType: "error",
      });
      return;
    }

    const form = e.currentTarget;

    this.setState({
      sending: true,
      status: "",
      statusType: "",
    });

    emailjs
      .sendForm(
        "service_a1ql1ng",
        "template_r1jmfzj",
        form,
        "SLN6hA9EBFlJ1uw2o"
      )
      .then(() => {
        form.reset();

        if (this.captchaRef.current) {
          this.captchaRef.current.reset();
        }

        this.setState({
          captcha: null,
          sending: false,
          status: "ההודעה נשלחה בהצלחה. משרדנו יחזור אליכם בהקדם.",
          statusType: "success",
        });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);

        if (this.captchaRef.current) {
          this.captchaRef.current.reset();
        }

        this.setState({
          captcha: null,
          sending: false,
          status: "שליחת ההודעה נכשלה. אנא נסו שוב.",
          statusType: "error",
        });
      });
  };

  handleCaptchaChange = (value) => {
    this.setState({
      captcha: value,
      status: "",
      statusType: "",
    });
  };

  render() {
    const { sending, status, statusType } = this.state;

    return (
      <section className="contact-section" dir="rtl">
        <div className="contact-container">

          <div className="contact-heading">
            <h2>אנחנו כאן כדי לסייע לכם</h2>

            <p>
              מתמודדים עם סוגיה משפטית בתחום דיני המשפחה?
              השאירו פרטים ונחזור אליכם בהקדם לתיאום שיחה
              ולקבלת מענה ראשוני.
            </p>
          </div>

          <div className="contact-grid">

            <form
              className="contact-form"
              onSubmit={this.sendEmail}
            >
              <div className="form-header">
                <span>פנייה למשרד</span>

                <h3>השאירו פרטים ונחזור אליכם</h3>
              </div>

              <div className="form-group">
                <label htmlFor="contact-name">
                  שם מלא
                </label>

                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  placeholder="הקלידו את שמכם המלא"
                  autoComplete="name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-phone">
                  מספר טלפון
                </label>

                <input
                  id="contact-phone"
                  type="tel"
                  name="phone"
                  placeholder="050-0000000"
                  autoComplete="tel"
                  dir="ltr"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-message">
                  במה נוכל לסייע?
                </label>

                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="כתבו בקצרה על הנושא המשפטי שבו אתם זקוקים לסיוע..."
                  rows="5"
                  required
                />
              </div>

              <div className="captcha-wrapper">
                <ReCAPTCHA
                  ref={this.captchaRef}
                  sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                  onChange={this.handleCaptchaChange}
                  onExpired={() => {
                    this.setState({ captcha: null });
                  }}
                />
              </div>

              {status && (
                <div
                  className={`form-status ${statusType}`}
                  role="status"
                  aria-live="polite"
                >
                  {status}
                </div>
              )}

              <button
                type="submit"
                className={`submit-btn ${sending ? "sending" : ""}`}
                disabled={sending}
              >
                {sending ? (
                  <>
                    <span className="spinner"></span>
                    <span>שולח פנייה...</span>
                  </>
                ) : (
                  <>
                    <span>שליחת פנייה</span>
                    <span className="submit-arrow">←</span>
                  </>
                )}
              </button>
            </form>

            <div className="contact-info">

              <div className="info-top">
                <div className="logo-wrapper">
                  <img
                    src="/logo192.png"
                    alt="רז יוסף – משרד עורכי דין"
                    className="logo-top"
                  />
                </div>

                <h3>
                  ליווי משפטי מקצועי
                  <br />
                  יחס אישי ודיסקרטי
                  <br />
                  מחויבות לאינטרסים שלכם
                </h3>

                <p>
                  משרד עורכי דין רז יוסף מעניק ייעוץ וייצוג
                  משפטי בתחומי דיני המשפחה, הגירושין והירושה,
                  תוך הקפדה על מקצועיות, יסודיות וליווי אישי
                  ודיסקרטי.
                </p>
              </div>

              <div className="info-details">

                <a
                  href="https://www.google.com/maps/search/?api=1&query=רחוב+האורזים+23+נתניה"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-item"
                >
                  <div className="info-icon">📍</div>

                  <div>
                    <span>כתובת המשרד</span>
                    <strong>רחוב האורזים 23, נתניה</strong>
                  </div>
                </a>

                <a
                  href="tel:0507575775"
                  className="info-item"
                >
                  <div className="info-icon">☎</div>

                  <div>
                    <span>טלפון</span>
                    <strong dir="ltr">050-757-5775</strong>
                  </div>
                </a>

                <a
                  href="mailto:raz290174@gmail.com"
                  className="info-item"
                >
                  <div className="info-icon">✉</div>

                  <div>
                    <span>דואר אלקטרוני</span>
                    <strong dir="ltr">
                      raz290174@gmail.com
                    </strong>
                  </div>
                </a>

                <div className="info-item">
                  <div className="info-icon">🕒</div>

                  <div>
                    <span>שעות פעילות</span>
                    <strong>ימים א׳–ה׳, 09:00–17:00</strong>
                  </div>
                </div>

              </div>

              <div className="info-services">
                <span>תחומי העיסוק</span>

                <div className="service-tags">
                  <span>דיני משפחה</span>
                  <span>גירושין</span>
                  <span>מזונות</span>
                  <span>משמורת ילדים</span>
                  <span>חלוקת רכוש</span>
                  <span>הסכמי ממון</span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    );
  }
}
